import React from 'react';

interface SegmentTooltipProps {
  label: string;
  children: React.ReactNode;
}

/**
 * Wraps a segment trigger and shows a dark tooltip on hover.
 * Tooltip grows with content width up to max-w-md.
 */
export const SegmentTooltip: React.FC<SegmentTooltipProps> = ({ label, children }) => {
  return (
    <div className="group relative flex-1 min-w-0 flex overflow-visible">
      {children}
      <span
        role="tooltip"
        className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 text-sm font-medium text-white rounded-md shadow-lg pointer-events-none select-none whitespace-normal text-left w-max max-w-md z-[9999] border-0 bg-[#111827] opacity-0 group-hover:opacity-100 transition-opacity duration-150 ease-out delay-0 group-hover:delay-200"
      >
        {label}
      </span>
    </div>
  );
};
